<template>
  <div class="purchase_Wrapper">
    <el-dialog :visible.sync="dialogTableVisibleTwo" width="80%">
      <div v-if="!isShow">
        <div
          style="
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <div style="display: flex">
            <div style="width: 80px; height: 80px; position: relative">
              <img
                style="width: 100%"
                :src="additionItem ? additionItem.image : ''"
              />
              <span style="position: absolute; top: -28px; left: 0; color: red"
                >{{$t('other.a2138')}}</span
              >
            </div>
            <div style="margin: 0 20px">
              <div style="color: #409eff">
                {{$t('other.a2139')}}：{{ additionItem ? additionItem.skuName : "" }}
              </div>
              <div style="padding: 5px 0; font-size: 14px">
                {{$t('other.a67')}}：{{ additionItem ? additionItem.cusCode : "" }}
              </div>
              <div style="font-size: 14px">
                skuName：{{
                  additionItem ? additionItem.variationName : $t('other.a354')
                }}
              </div>
            </div>
          </div>
          <div>
            <el-button
              v-show="!isEditGoods"
              type="primary"
              @click="editorSuscode"
              >{{$t('other.a238')}}</el-button
            >
            <el-button v-show="isEditGoods" type="primary" @click="addGoods"
              >{{$t('other.a2140')}}</el-button
            >
            <el-button v-show="isEditGoods" type="danger" @click="saveItems"
              >{{$t('other.a216')}}</el-button
            >
            <el-button
              v-show="isEditGoods"
              type="primary"
              @click="isEditGoods = false"
              >{{$t('other.a146')}}</el-button
            >
          </div>
        </div>
        <el-table :data="additionParents" height="450px">
          <el-table-column
            width="80"
            :label="$t('other.a66')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-popover placement="top-start" title="" trigger="hover">
                <img
                  :src="scope.row.image"
                  alt=""
                  style="width: 150px; height: 150px"
                />
                <img
                  slot="reference"
                  :src="scope.row.image"
                  style="width: 30px; height: 30px"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            :label="$t('other.a67')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.cusCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="sku" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a2141')">
            <template slot-scope="scope">
              <span>{{ scope.row.component ? $t('other.a251') : $t('other.a252') }}</span>
            </template>
          </el-table-column>
          <el-table-column >
            
            <template slot-scope="scope">
              <el-input-number
                size="mini"
                v-show="isEditGoods"
                v-model="scope.row.rate"
                :min="1"
              ></el-input-number>

              <span v-show="!isEditGoods">{{ scope.row.rate }}</span>
            </template>

                <template  slot="header">
					<el-tooltip effect="light" :content="$t('other.a2142')" placement="top">
						<span>{{$t('other.a2143')}}<i class="el-icon-question" style="font-size:22px;margin:0 10px"></i></span>
						
					</el-tooltip>
					</template>
          </el-table-column>
          <el-table-column
            :label="isEditGoods ? $t('other.a33') : ''"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                v-show="isEditGoods"
                size="mini"
                type="danger"
                @click="deletGoods(scope.row, scope.$index)"
                >{{$t('other.a312')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <div style="display: flex; justify-content: space-between">
          <div>
            <el-button size="small" type="primary" @click="isShow = false">
             
              {{$t('other.a605')}}</el-button
            >
            <span style="margin-left: 15px; font-size: 18px"
              >{{$t('other.a2144')}}：({{ multipleSelection.length }})</span
            >
          </div>
          <div style="display: flex">
            <el-select
              @change="getTableList()"
              v-model="value"
              :placeholder="$t('other.a50')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input style="width:350px"  v-model="searchCuscode" placeholder="可搜索仓库编码，商品名，sku" clearable></el-input>
						<el-button type="primary" @click="search()">{{$t('other.a27')}}</el-button> -->
          </div>
        </div>
        <div>
          <el-table
            :data="tableList"
            height="400px"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="outTradeNo" :label="$t('other.a66')" width="80">
              <template slot-scope="props">
                <el-popover placement="top-start" title="" trigger="hover">
                  <img
                    :src="props.row.image"
                    alt=""
                    style="width: 150px; height: 150px"
                  />
                  <img
                    slot="reference"
                    :src="props.row.image"
                    style="width: 30px; height: 30px"
                  />
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a67')" width="180">
              <template slot-scope="props">
                <span>{{ props.row.cusCode }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="itemName" :label="$t('other.a1901')"> </el-table-column>
            <el-table-column prop="skuName" label="SKU"> </el-table-column>
            <el-table-column prop="platform" :label="$t('other.a2143')">
              <template slot-scope="props">
                <el-input-number
                  size="mini"
                  v-model="props.row.rate"
                  :min="1"
                ></el-input-number>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage4"
              :page-sizes="[15, 30, 50, 100]"
              :page-size="15"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="!isShow"
          type="primary"
          @click="dialogTableVisibleTwo = false"
          >{{$t('other.a5')}}</el-button
        >
        <el-button v-show="isShow" type="primary" @click="addItem()"
          >{{$t('other.a279')}}</el-button
        >
      </span>
    </el-dialog>

   
    <div class="header_top">
      <div>{{itemsCount}}{{$t('other.a1326')}}</div>
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <div style="display:flex">
          <div style="width: 150px">
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="warehouseId"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in warehouseOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div style="width: 150px;margin:0 10px">
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="componentValue"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
   
        <div >
          <el-input
            style="width: 320px;"
            clearable
            :placeholder="$t('other.a1327')"
            v-model="cusCode"
          ></el-input>
          <el-button type="primary" @click="getStoreItemAndGroup()">{{
            $t("userStoreItems").search
          }}</el-button>
        </div>
        </div>
        <div class="create">
           
            <el-button type="primary"  @click="toPurchase()">{{$t('other.a1328')}}</el-button>
            <span class="cirlle">{{targetList.length}}</span>
           
        </div>
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="goodsArea">
      <div class="my-goods-data">
        <div
          class="list-item"
          v-for="(outeritem, indexOne) in newUserstoreItem"
          :key="indexOne"
        >
          <div style="border-bottom: 1px solid #e0e0e0">
            <div class="outPsku">
              <div class="outPsku_left">

                <span style="color: red; font-size: 18px; margin-left: 15px">
                  {{$t('other.a2145')}}：</span
                >
                <span
                  style="color: red; font-size: 18px"
                  v-show="!outeritem.checked01"
                  >{{ outeritem.itemSku }}</span
                >
              </div>

              <div class="outPsku_right">
                <el-button
                  style="margin-left:20px;min-width:160px;"
                  type="primary"
                  @click="outeritem.checked02 = !outeritem.checked02"
                  >{{$t('other.a2146')}}/{{$t('other.a2147')}}</el-button
                >
                <el-button
                  style="margin-left:20px;min-width:160px;"
                  :type="outeritem.checked ? 'danger'  : 'primary'"
                  @click="isTargetAll(outeritem, 1, indexOne, null)"
                  >{{outeritem.checked ? $t('other.a146') : $t('other.a2148')}}</el-button
                >
              </div>
            </div>

            <div class="outDesc">
              <div style="display: flex">
                <div class="goods-pic">
                  <img
                    v-image-preview
                    :src="
                      outeritem.image
                        ? outeritem.image
                        : outeritem.storeItems
                        ? outeritem.storeItems[0].image
                        : ''
                    "
                  />
                
                </div>
                <div style="width: 300px; margin-left: 20px">
                  {{
                    outeritem.storeItems
                      ? outeritem.storeItems[0].itemName
                      : " "
                  }}
                </div>
                <div style="width: 180px; margin-left: 20px; text-align: right">
                  <div>
                    {{$t('other.a2149')}}：{{
                      outeritem.storeItems ? outeritem.storeItems.length : 0
                    }}
                  </div>
                  <div>{{$t('other.a2150')}}：{{ outeritem.qytInStore }}</div>
                </div>
           
              </div>
            </div>
          </div>
          <div
            v-show="!outeritem.checked02"
            class="childrenItem"
            v-for="(item, index) in outeritem.storeItems
              ? outeritem.storeItems
              : []"
            :key="index"
          >
            <div class="goods-title-desc-wrapper">
              <div class="check_And_Img">
               
                <div
                  style="
                    width: 60px;
                    height: 60px;
                    margin: 20px 10px 0 0;
                    position: relative;
                  "
                >
                  <img v-image-preview width="100%" :src="item.image" />
                  
                </div>
                <div class="goods-title-desc-box">
                  <div
                    style="font-size: 16px; color: red; padding-bottom: 5px"
                    v-if="isEdit !== index"
                  >
                    {{$t('other.a2139')}}：{{ item.skuName }}
                  </div>
                  <div v-else>
                    <el-input
                      size="mini"
                      style="width: 200px"
                      v-model="item.skuName"
                      :rows="2"
                      type="textarea"
                      :placeholder="$t('other.a2151')"
                      autosize="autosize"
                    >
                    </el-input>
                  </div>

                  <div
                    style="font-size: 16px; padding-bottom: 5px"
                    v-if="isEdit !== index"
                  >
                    skuName：{{ item.variationName }}
                  </div>
                  <div v-else>
                    <el-input
                      size="mini"
                      style="width: 200px"
                      v-model="item.variationName"
                      :rows="2"
                      type="textarea"
                       :placeholder="$t('other.a2152')"
                      autosize="autosize"
                    >
                    </el-input>
                  </div>
                  <div class="goods-item-a">
                    {{ $t("userStoreItems").cusCode }}：{{ item.cusCode }}
                  </div>
                  <div class="goods-item-a"></div>
                </div>
              </div>

              <div class="goods-title-desc">
                <div class="goods-item-a">
                  {{ $t("userStoreItems.Quantitytobeshipped") }}：{{
                    item.auditedStock
                  }}
                </div>
                <div class="goods-item-a">
                  {{ $t("userStoreItems").shipping_stock }}：{{
                    item.unShipped
                  }}
                </div>

                <div class="goods-item-a">
                  {{ $t("userStoreItems").total_stock }}：{{ item.storeNum }}
                </div>
              </div>
              <div class="goods-title-desc bbp">
                <div class="goods-item-a">
                  <div>
                    {{$t('other.a2153')}}：{{ item.packageLength ? item.packageLength : 0 }}({{$t('other.a1255')}})
                    x {{ item.packageWidth ? item.packageWidth : 0 }}({{$t('other.a1256')}}) x
                    {{ item.packageHeight ? item.packageHeight : 0 }}({{$t('other.a1257')}}) cm
                  </div>
                </div>

                <div class="goods-item-a">
                  <div>
                    {{ $t("userStoreItems.weight") }}：{{
                      item.weight ? item.weight : 0
                    }}
                    kg
                  </div>
                </div>
                <div class="goods-item-a">
                  <div>{{$t('other.a1169')}}：{{ item.address ? item.address : $t('other.a354') }}</div>
                </div>
              </div>

              <div class="btn-wrapper">
                <div v-show="item.independent || item.component" class="btn-item-desc">
              
                <!-- <el-checkbox
                  v-model="item.checked"
                  style="margin-right: 20px"
                  @change="getPsku(item, 2, indexOne, index)"
                >
                </el-checkbox> -->

                 <el-button
                    style="min-width: 160px"
                    :type="item.checked ? 'danger'  : 'primary'"
                    size="medium"
                    @click="isTarget(item, 2, indexOne, index)"
                    >{{item.checked ? $t('other.a2144')  : $t('other.a1334')}} </el-button
                  >

                 
               
                
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="Pager">
          <el-pagination
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="currentPage"
            :page-sizes="[15, 20, 30, 100]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemsCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import userStoreItems from "../../api/moudles/userStoreItems";
import QrcodeDialog from '../../components/dialog/qrcodeDialog'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      openDialog: false,
      warehouseId: null,
      warehouseOption: null,
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      offset: 15,
      instockdia:false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      targetList: [],
      isExtened: false,
      maincusCode:0,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      listErrorOptions: [],
      itemsCount:0,
      tableList: [],
      tableCount: 0,
      currentPage4: 1,
      currentPage:1,
      page: 0,
      componentValue:1,
      value: null,
       options2: [
        {
          label: this.$t('other.a251'),
          value: 1,
        },
        {
          label: this.$t('other.a252'),
          value: 2,
        },
        {
          label: this.$t('other.a497'),
          value: 3,
        },
      ],
      options: [
        {
          label: this.$t('other.a1340'),
          value: null,
        },
        {
          label: this.$t('other.a1341'),
          value: true,
        },
        {
          label: this.$t('other.a1342'),
          value: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
      isChooseList: (state) => state.userStoreItems.isChooseList
    }),
  },
  watch: {
      
    cusCode(){
      if(!this.cusCode){
        this.getStoreItemAndGroup()
      }
    },
    checkedAll() {
      if (this.checkedAll) {
        this.newUserstoreItem.forEach((k) => {
          k.checked = true;
          k.storeItems.forEach((p) => {
            p.checked = true;
            let flag = this.targetList.some(
              (item) => item.cusCode === p.cusCode
            );
            console.log("flag", flag);
            if (!flag) {
              this.targetList.push(p);
            }
          });
        });
      } else {
        this.newUserstoreItem.forEach((k) => {
          k.checked = false;
          k.storeItems.forEach((p) => {
            p.checked = false;
            this.targetList = [];
          });
        });
      }
    },
    targetList() {
      let arr = [];
      this.targetList.forEach((p) => {
        if (p.checked) {
          p.num=1,
          p.anotherName='',
          p.variation = p.variation ?  p.variation : {
					variationId: 0,
					name: '',
					stock: 0
				} 
          arr.push(p);
        }
      });
      console.log("targetList", arr);
    },
    dialogTableVisibleTwo() {
      if (!this.dialogTableVisibleTwo) {
        this.isEditGoods = false;
        this.additionParents = [];
        this.isShow = false;
      }
    },
    isExtened() {
      if (this.isExtened) {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = true;
        });
      } else {
        this.newUserstoreItem.forEach((p) => {
          p.checked02 = false;
        });
      }
    },
  },

  created() {
    let arr1=[]
    let arr2=[]
    
    JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
      if(p.isUsed){

        if(p.storeType == 1){
          arr1.push( {
          label: p.storeName,
          value: p.storeId,
        })
        }else{
          arr2.push( {
          label: p.storeName,
          value: p.storeId,
        })
        }
      }
     
    });
    this.warehouseOption = [...arr1,...arr2]
    this.warehouseId = this.warehouseOption[0].value
   console.log(this.warehouseId)
    this.getStoreItemAndGroup();
    console.log(this.warehouseId);
  },
  methods: {
    

    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
        'deleStoreItems'
    ]),


    ...mapMutations('userStoreItems', [
        'SET_ITEMS_COUNT',
        

    ]),

    toPurchase(){
       
        if(this.$route.query.purchaseId){
         
            utils.cleanStorageData()
            localStorage.setItem('purchaseItems',JSON.stringify(this.targetList))
            this.$router.push({path:'/purchaseDetail',query:{purchaseId:this.$route.query.purchaseId}})
        }else{
         
          //  this.SET_ITEMS_COUNT(this.targetList)
            utils.cleanStorageData()
            localStorage.setItem('purchaseItems',JSON.stringify(this.targetList))
            this.$router.push({path:'/purchaseDetail',query:{storeId:this.warehouseId,}})
        }
        
    },

    getTime01(time){
        return utils.renderTime(time)
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },

    addItem() {
      this.multipleSelection.forEach((p) => {
        this.additionParents.push(p);
      });
      this.isShow = false;
      console.log("additionParents", this.additionParents);
    },

    massMoveInSingle(item) {
      this.additionItem = item;
      console.log(item);
      this.additionParents = [];
      this.additionParents = JSON.parse(JSON.stringify(item.additionParents));
      this.dialogTableVisibleTwo = true;
      console.log(this.additionParents);
    },
    massDeletd() {
      let arr = [];
      let num = 0;
      this.targetList.forEach((p) => {
        arr.push({
          cusCode: p.cusCode,
          userId: this.userId,
          storeId: this.warehouseId,
        });
      });
      let desc = this.$t('other.a2154') + arr.length + this.$t('other.a2155');
      this.$confirm(desc, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning",
      }).then(() => {
        userStoreItems.massDeleteStoreItem(arr).then((res) => {
          if (res.code === 200) {
            res.data.forEach((p) => {
              if (p.code == 0) {
              } else {
                this.listErrorOptions.push({
                  cusCode: p.cusCode,
                  desc: p.msg,
                });

                this.qty = this.listErrorOptions.length + this.$t('other.a2156');
                this.errorDia = true;
                this.resetPage();
              }
            });

            if (!this.listErrorOptions.length) {
              this.$message.success(this.$t('other.a565'));
              this.getStoreItemAndGroup();
            }
          }
        });
      });
    },

    deleStoreItem(code, outerItem) {
      this.$confirm(this.$t('other.a2157'), this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning",
      }).then(() => {
        console.log(123);
        let param = {
          cusCode: code,
          userId: this.userId,
          storeId:this.warehouseId
        };

        this.deleStoreItems(param).then((res) => {
          if (res.code == 200) {
            if (res.data.code == 0) {
              this.$message.success(this.$t('other.a565'))
              this.getStoreItemAndGroup()
            }else if(res.data.code == 600){
              this.$message.success(res.msg)
            } else {
              this.listErrorOptions = [
                {
                  cusCode: res.data.cusCode,
                  desc: res.data.msg,
                },
              ];
              this.qty = 1 + this.$t('other.a2158');
              this.errorDia = true;
            }
          }
        });
      });
    },

    massChagnePSKU() {},

    fixItemSku(item) {
      console.log(item);
      item.checked01 = false;
      item.groupName = item.itemSku;
      this.updateGroup(item);
    },
    confirm(item) {
      console.log(item);
      this.sellerUpdateStoreItemDetail(item);
      this.isEdit = -1;
    },

    editorSuscode() {
      this.isEditGoods = !this.isEditGoods;
    },

    addGoods() {
      this.isShow = true;
      this.getTableList();
    },

    deletGoods(item, index) {
      this.additionParents.splice(index, 1);
    },

    saveItems() {
      this.isEditGoods = !this.isEditGoods;
      let arr = this.additionParents.map((p) => {
        return {
          childrenId: this.additionItem.cusCode,
          parentId: p.cusCode,
          rate: p.rate,
        };
      });
      let params = {
        binds: arr,
        parentId: this.additionItem.cusCode,
        userId: this.userId,
      };

      console.log(params);
      // this.updateBindStoreItem(params)
      userStoreItems
      .updateBindStoreItemAddition(params)
      .then(res => {
        if(res.code === 200) {
          this.$message.success(this.$t('other.a2159'))
          this.getTableList()
          this.isEditGoods=false

        }
      })
    },

    getTableList() {
      let params = {
        offset: this.offset,
        page: this.page,
        userId: this.userId,
        storeId: this.warehouseId,
        sellerId: this.userId,
        component: this.value,
        cusCode: "",
      };
      console.log("params", params);
      userStoreItems.getStoreItemBystore(params).then((res) => {
        if (res.code === 200) {
          console.log("套餐或单品", res.data);
          this.tableList = res.data.items;
          this.tableCount = res.data.count;
        }
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.getTableList();
    },
    //显示当前第几页
    handleCurrentChange(val) {
      this.currentPage4 = parseInt(`${val}`);
      this.page = (parseInt(`${val}`) - 1) * this.offset;
      this.getTableList();
      console.log(this.page);
    },


    	viewstoreoperaterecord(item){
				this.instockdia=true
        this.maincusCode=item.cusCode
				let params={
					cusCode:item.cusCode,
					end:utils.getchinastadarTime(0),
					start:utils.getchinastadarTime(-7),
					offset:50,
					page:0,
					userId:this.userId
				}
				console.log(params)
				this.getInstockoperaterecore(params)
			},
    isTarget(item, num, indexOne, index) {
        this.newUserstoreItem[indexOne].storeItems[index].checked=!this.newUserstoreItem[indexOne].storeItems[index].checked
        this.getPsku(item, num, indexOne, index)
    },   
    isTargetAll(item, num, indexOne, index){
        this.newUserstoreItem[indexOne].checked=!this.newUserstoreItem[indexOne].checked
         this.getPsku(item, num, indexOne, index)
    },

    getPsku(item, num, indexOne, index) {
      console.log(item, num, indexOne, index);
      if (num == 1) {
        if (!item.checked) {
          let list = this.targetList.filter(
            (p) => !item.storeItems.some((ele) => ele.cusCode === p.cusCode)
          );
          console.log(list);
          this.targetList = list;

          item.storeItems.forEach((p) => {
            p.checked = false;
          });

          return;
        }
        item.storeItems.forEach((p) => {
          p.checked = true;
          let flag = this.targetList.some((item) => item.cusCode === p.cusCode);
          console.log("flag", flag);
          if (!flag) {
            this.targetList.push(p);
          }
        });
      } else {
        if (!item.checked) {
          this.targetList.forEach((p, index) => {
            if (p.cusCode == item.cusCode) {
              this.targetList.splice(index, 1);
            }
          });
          return;
        }
        this.targetList.push(item);
      }

      console.log(this.targetList);
    },

    createItemNotProduct(data) {
      console.log("data", data);
      let params = {
        addition: true,
        image: data.imageUrl,
        userId: this.userId,
        storeId: this.warehouseId,
        groupId: this.handleParam ? this.handleParam.groupId : null,
        groupName: this.handleParam ? this.handleParam.groupName : null,
        itemSku: this.handleParam ? this.handleParam.groupName : null,
        component: true,
        groupName: data.name,
        packageHeight: data.height,
        packageLength: data.long,
        packageWidth: data.width,
        weight: data.weigth,
      };
      console.log("params", params);
      userStoreItems.addStoreItemNotProduct(params).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2160'));
          this.handleParam = null;
          this.getStoreItemAndGroup()
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    handleCreate(item) {
      console.log(item);
      this.handleParam = item;
      this.openDialog = true;
      this.TitleDesc = this.$t('other.a2161');
    },
    getStoreItemAndGroup() {
    this.getDataList = {
      offset: this.offset,
      page: this.page,
      userId: this.userId,
      storeId: this.warehouseId,
      sellerId: this.userId,
      addition: this.componentValue == 3 ? true : false,
      component:  this.componentValue == 1 ? true : this.componentValue == 3 ? true : false,
      cusCode: this.cusCode,
      isEdit: false,
    };
      //获取页面赠品的数据
      this.getData()
    },

    getData(){
      userStoreItems.getStoreItem(this.getDataList).then((res) => {
        if (res.code === 200) {
          console.log("赠品item", res.data);
          this.itemsCount=res.data.count
           this.newUserstoreItem=[]
          if(!res.data.groups.length){
            this.newUserstoreItem=[]
            return
          }
          res.data.groups.forEach((p) => {
            p.checked01 = false;
            p.checked02 = false;
            p.storeItems.forEach((k) => {
              k.checked = false;
            });
            this.newUserstoreItem.push(p);
          });
        }
      });
    },

    //控制每页显示订单条数
    handleSizeChangeTwo(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.getDataList.offset = parseInt(`${val}`);
      this.handleCurrentChange();
    },
    //显示当前第几页
    handleCurrentChangeTwo(val) {
      // console.log(`${val}`);
      // this.resetPage();
      this.currentPage = parseInt(`${val}`);
      let ppg =`${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.offset;
      this.getDataList.page = ppg;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.purchase_Wrapper {
  margin-top: 70px;
 
  // @include main-right-content();

  .Pager{
    position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
    position: fixed;
    width: 100%;
    top:50px;
    box-sizing: border-box;
    
    padding: 10px 225px 10px 0;
    background-color: #fff;
    z-index: 9;
    border-bottom: 1px solid #eee;

    .query-list-tcp {
      padding: 10px 0 20px 0;
    }
    .query_list {
    
      padding: 20px 0 20px 0;
      @include flex-between();
    }

    .create {
		position: relative;
		margin-left: 30px;
	}

    .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
  }

  .goodsArea {
    margin-top: 135px;
    margin-bottom: 120px;
  }

  .list-item {
    padding: 0 20px 0 0;
    margin-bottom: 10px;

    .childrenItem {
      padding: 10px 0 5px 25px;
      border-bottom: 1px solid #eee;

      .goods-title-desc-wrapper {
        @include flex-between();

        .check_And_Img {
          display: flex;
        }
      }
    }

    .outPsku {
      @include flex-between();
      align-items: center;

      .outPsku_left {
        display: flex;
        align-items: center;

        .el-input {
          width: 300px;
        }

        .el-icon-edit {
          margin-left: 15px;
          cursor: pointer;
          color: #409eff;
          font-size: 18px;
        }
      }

      .outPsku_right {
        display: flex;
        align-items: center;
      }
    }

    .btn-item-desc {
      padding: 0 0 8px 0;
    }

    .outDesc {
      @include flex-between();

      .goods-pic {
        width: 80px;
        height: 80px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>